export var TemplateType;
(function (TemplateType) {
    TemplateType["HEADER"] = "header";
    TemplateType["FOOTER"] = "footer";
})(TemplateType || (TemplateType = {}));
